export const Customers = () => import('./Customers').then(({ Customers }) => {
  return {
    Component: Customers
  };
});
